<template>
  <div>
    <Header></Header>
    <!-- Skeleton  -->
    <offer></offer>
  </div>
</template>

<script>
import Header from '@/components/SkeletonLoader/Header'
import offer from '@/components/SkeletonLoader/Offers'

export default {
  name: 'App',
  components: {
    Header,
    offer,
  },
  computed: {},
  mounted() {},
}
</script>
